import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import _ from 'underscore';

import {cssClassMap} from 'rendering-commons/SportCssMap';

const messages = defineMessages({
    Rate: {
        id: 'bet_history.rate',
        defaultMessage: 'Коэфф: '
    },
    Stake: {
        id: 'bet_history.stake',
        defaultMessage: 'Ставка: '
    },
    rateChanged: {
        id: 'coupon.rate_changed',
        defaultMessage: 'Коэфф недоступен'
    },
    rateUnavailable: {
        id: 'coupon.rate_unavailable',
        defaultMessage: 'Прием закрыт'
    }
});

class BetRate extends React.Component {
    static propTypes = {
        rate: React.PropTypes.object.isRequired,
        score: React.PropTypes.object,
        match: React.PropTypes.object.isRequired,
        outcome: React.PropTypes.object.isRequired,
        rateChange: React.PropTypes.array,
        languageId: React.PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {rate, match, score, outcome, rateChange} = this.props;

        const odd = rate.get('value');

        let rateSpan = (
            <span className="event-rate">
                <FormattedMessage {...messages.Rate} />
                <strong>{odd}</strong>
            </span>);

        const sportIconCls = 'sport-icon svg-' + cssClassMap[rate.get('sportId')];

        if (rateChange) {
            const factorRateChange = _.find(rateChange, {factorId: rate.get('id')});

            if (factorRateChange) {
                const newFactorOdd = factorRateChange.value;
                const factorUnavailable = factorRateChange.unavailable;

                if (newFactorOdd) {
                    let cls = 'new-rate';
                    if (odd < newFactorOdd) {
                        cls += ' up';
                    } else {
                        cls += ' down';
                    }

                    rateSpan = (
                        <div className="rate changed">
                            <FormattedMessage {...messages.Rate} />
                            <span className="old-rate">{odd}</span>
                            {'\u00A0'}
                            <span className={cls}>{newFactorOdd}</span>
                            <FormattedMessage {...messages.rateChanged}>
                                {(message) => <span className="event-rate event-rate__unavailable">{message}</span>}
                            </FormattedMessage>
                        </div>);
                } else if (factorUnavailable) {
                    rateSpan =
                        (<span className="event-rate">
                            <FormattedMessage {...messages.Rate} />
                            <strong>{odd}</strong>
                            <FormattedMessage {...messages.rateUnavailable}>
                                {(message) => <span className="event-rate event-rate__unavailable">{message}</span>}
                            </FormattedMessage>
                        </span>);
                }
            }
        }

        let scoreSpan = undefined;

        if (score) {
            let score1 = score.get('score1');
            let score2 = score.get('score2');
            if (score1 && score2) {
                score1 = score1 === undefined ? 0 : score1;
                score2 = score2 === undefined ? 0 : score2;

                scoreSpan = (
                    <span className="current-score">
                        <strong>{score1 + ':' + score2}</strong>
                    </span>);
            }
        }

        let matchName = match.get('name');
        if (match.get('notice')) {
            matchName += '(' + match.get('notice') + ')'
        }

        return (
            <li className="bet-history-list-item">
                    <span className="event-name">
                        <span className={sportIconCls}/>
                        {scoreSpan}
                        {matchName}<br/>
                        {outcome.get('name')}
                    </span>
                <span className="event-type">
                    <FormattedMessage {...messages.Stake} />
                    <strong>{rate.get('shortName')}</strong>
                </span>
                {rateSpan}
            </li>
        );
    }
}

function select(state, props) {
    const id = props.id;
    const rateId = props.rateId;
    const bet = state.application.getIn(['betHistory', id]);
    const betSlip = bet.get('betSlips').find(bs => bs.getIn(['rate', 'id']) === rateId);
    const rate = betSlip.get('rate');
    const score = betSlip.get('score');
    const match = betSlip.get('match');
    const outcome = betSlip.get('outcome');
    const rateChange = bet.get('rateChange');
    const languageId = state.application.get('languageId');

    return {
        rate,
        score,
        match,
        outcome,
        rateChange,
        languageId
    };
}

export default connect(select)(BetRate);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/bet-history/BetRate.jsx